/**
 * Configuration
 */

export const baseURL = process.env.REACT_APP_TARGET_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:4040/api' : `${window.location.protocol}//${window.location.host}/api`)
console.log(`API URL: ${baseURL}`)



// WEBPACK FOOTER //
// ./src/constants/index.js